<template>
    <div class="z-logo">
        <template v-if="isIndex">
            <img :src="buildSrc" class="z-logo__img" :alt="siteTitle">
        </template>
        <template v-else>
            <a :href="siteDir" class="z-logo__link" :title="title">
                <img :src="buildSrc" class="z-logo__img" :alt="siteTitle">
            </a>
        </template>
    </div>
</template>

<script setup>
import { computed } from 'vue'
import { localize } from '@/utils/i18n'

const props = defineProps({
    isIndex: {
        type: Boolean
    },
    siteDir: {
        type: String,
        default: '/',
        required: true
    },
    theme: {
        type: String,
        default: ''
    },
    size: {
        type: String,
        default: ''
    },
    src: {
        type: String,
        default: ''
    }
})

const title = localize({
    ru: 'Перейти на главную страницу',
    en: 'Go to Main Page',
    cn: '首页'
})
const siteTitle = localize({
    ru: 'Иркутская нефтяная компания',
    en: 'Irkutsk Oil Company',
    cn: '首页'
})

const image = localize({
    ru: '/media/img/logo/logo-25-white.png',
    en: '/media/img/logo/logo-25-white.png',
    cn: '/media/img/logo/cn-logo-25-white.webp'
})

const buildSrc = computed(() => {
    if (props.src) {
        return props.src
    } else return image
})

defineExpose({
    props
})
</script>

<style lang="scss" src="./index.scss"></style>
